/** IconButton `medium` footprint — shared collapse alignment across board topbar and page headers. */
// biome-ignore lint/plugin: shared layout token consumed across many headers; inlining would duplicate strings
export const WORKSPACE_PANEL_COLLAPSE_SLOT_CLASS = 'flex size-8 shrink-0 items-center justify-center';

/** Large page title typography (text-24 headers). */
// biome-ignore lint/plugin: shared layout token consumed across many headers; inlining would duplicate strings
export const PAGE_HEADER_LARGE_TITLE_CLASS = 'px-2 py-1 font-semibold text-24 leading-8 ads:text-primary text-gray-12';

/** Centers toolbar content in a BoardTopbar-height row (h-14). */
// biome-ignore lint/plugin: shared layout token consumed across many headers; inlining would duplicate strings
export const PAGE_HEADER_TOOLBAR_ROW_GRID_CLASS = 'h-14 items-center';

/** Split-layout top chrome — shared by board topbar and non-board workspace collapse row. */
// biome-ignore lint/plugin: shared layout token consumed across many headers; inlining would duplicate strings
export const WORKSPACE_SPLIT_TOPBAR_ROW_CLASS =
  'group/board-topbar z-30 flex h-14 shrink-0 items-center justify-between ads:bg-glass/85 bg-gray-1/85 px-4 backdrop-blur-[18px]';
